// WhatsApp
export const WHATSAPP_NO_LIST = '/api/wp_profile.php';
export const WHATSAPP_TEMPLATE_LIST = '/api/whatsapp_template.php';
export const WHATSAPP_OPTIN_OPTOUT = '/api/wp_optinout.php';
export const WHATSAPP_MEDIA_GALLERY = '/api/uploadFileWhatsapp.php';
export const CONVERSATION_API = '/api/netcore_conversation.php';
// Campaign
export const CAMPAIGN_CONTACT_LIST_API = '/api/contact-list.php';
export const CAMPAIGN_CONTACT_LIST_API_2 = 'https://napi3.authkey.io/api2/v1/user/contact_list'
export const CAMPAIGN_CAMPAIGN = '/api/bulk_campaign.php';
export const CAMPAIGN_REPORT = '/api/bulk_campaign.php';

// admin Api
export const ADMIN_USERS_LIST = '/api/admin_user_list.php';


